import { MediaAuthor, MediaNarrator } from '@calm/evexia-web-sdk';

export enum ContributorType {
    Author,
    Narrator,
}
export type Contributor = MediaAuthor | MediaNarrator;

export type ContributorSelection = {
    contributor: MediaNarrator | MediaAuthor;
    contributorType: ContributorType;
};
